module.exports = __webpack_public_path__ + "img/TapQR.86be6de8.png";